export function getLocationLabel(location: number, type: 'judging'|'game', locationNames?: {[index: string]: string}) {
  if(locationNames?.[location]) {
    return locationNames[location];
  }

  if(type === 'judging') {
    return `Room ${location}`;
  }

  return `Table ${location}`;
}

export function getLocalTimeString(time?: number, multiDay?: string) {
  if (!time) return '';

  const tzoffset = new Date(time).getTimezoneOffset() * 60000;
  const str = new Date(time - tzoffset).toISOString().slice(0, 16);

  return multiDay ? str : str.split('T')[1];
}

export function shuffleArray(array: unknown[]) {
  for (var i = array.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
}

export function generateHash(s: string) {
  let hash = 0;
  for (const char of s) {
    hash = (hash << 5) - hash + char.charCodeAt(0);
    hash |= 0; // Constrain to 32bit integer
  }
  return hash;
};

export const KEY_REGEX = /^[a-zA-Z0-9]+$/;

export function getPlaceLabel(num: number, format:'ordinal'|'finalists') {
  if(format === 'ordinal') {
    switch(num) {
      case 1: return '1st';
      case 2: return '2nd';
      case 3: return '3rd';
      default: return `${num}th`;
    }
  }

  return num === 1 ? 'Winner' : 'Finalist';
}

export function csvEncodeString(value?: string|null) {
  if(!value) {
    return '';
  }

  const escapedValue = value.replace(/"/g, '""').replaceAll('#', '');
  return `"${escapedValue}"`;
}
